(function () {
  const consentKey = 'wm_cookie_consent_v1';
  const wishlistKey = 'wm_wishlist_v1';
  const collectionReturnKey = 'wm_last_collection_url_v1';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey)) || [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
  }

  function syncWishlistButtons() {
    const wishlist = readWishlist();
    document.querySelectorAll('[data-wm-wishlist-button]').forEach((button) => {
      const handle = button.dataset.productHandle;
      const active = wishlist.includes(handle);
      const label = active ? 'Saved' : 'Save';
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${label} ${button.dataset.productTitle || 'product'}`);
      const text = button.querySelector('[data-wm-wishlist-text]');
      if (text) text.textContent = label;
    });
  }

  function initWishlist() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wm-wishlist-button]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const wishlist = readWishlist();
      const index = wishlist.indexOf(handle);
      if (index >= 0) wishlist.splice(index, 1);
      else wishlist.push(handle);
      writeWishlist(wishlist);
      syncWishlistButtons();
    });

    syncWishlistButtons();
    document.addEventListener('shopify:section:load', syncWishlistButtons);
  }

  function initCookieConsent() {
    const banner = document.querySelector('[data-wm-cookie-consent]');
    if (!banner || localStorage.getItem(consentKey) === 'accepted') return;
    banner.classList.add('is-visible');
    banner.querySelector('[data-wm-cookie-accept]')?.addEventListener('click', () => {
      localStorage.setItem(consentKey, 'accepted');
      banner.classList.remove('is-visible');
    });
  }

  function initProductShare() {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-wm-share-button]');
      if (!button) return;

      const shareUrl = button.dataset.shareUrl || window.location.href;
      const shareTitle = button.dataset.shareTitle || document.title;

      if (navigator.share) {
        try {
          await navigator.share({ title: shareTitle, url: shareUrl });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }

      try {
        await navigator.clipboard.writeText(shareUrl);
        const text = button.querySelector('[data-wm-share-text]');
        const originalText = text ? text.textContent : '';
        button.classList.add('is-copied');
        if (text) text.textContent = 'Copied';
        window.setTimeout(() => {
          button.classList.remove('is-copied');
          if (text) text.textContent = originalText || 'Share';
        }, 1800);
      } catch (error) {
        window.prompt('Copy this product link', shareUrl);
      }
    });
  }

  function storeCollectionReturn() {
    if (!/\/collections\//.test(window.location.pathname)) return;
    localStorage.setItem(collectionReturnKey, window.location.href);
  }

  function initCollectionContinuity() {
    storeCollectionReturn();

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-wm-collection-product-link], .grid__item a[href*="/products/"]');
      if (!link || !/\/collections\//.test(window.location.pathname)) return;
      localStorage.setItem(collectionReturnKey, window.location.href);
    });

    const returnUrl = localStorage.getItem(collectionReturnKey);
    if (!returnUrl) return;

    document.querySelectorAll('[data-wm-return-collection-link]').forEach((link) => {
      link.href = returnUrl;
      if (link.classList.contains('wm-back-link')) {
        link.textContent = 'Back to collection';
      }
    });

    document.querySelectorAll('[data-wm-preserve-collection-link]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('return_to', returnUrl);
        link.href = url.toString();
      } catch (error) {
        // Keep the original link if the browser cannot parse it.
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCookieConsent();
      initWishlist();
      initProductShare();
      initCollectionContinuity();
    });
  } else {
    initCookieConsent();
    initWishlist();
    initProductShare();
    initCollectionContinuity();
  }
})();
